export default __webpack_public_path__ + "static/media/fleece.fdbf6d2d.jpg";